// extracted by mini-css-extract-plugin
export default {"container":"upscaleErrorModal_container__V+v2v","message":"upscaleErrorModal_message__iKTd1","buttonText":"upscaleErrorModal_buttonText__s7e3D"};